<template>
    <div class="h-100">
        <div class="map-wrapper" :class="{ active: show.map }">
            <Map
                map-id="attractionMap"
                :ori-map-points="oriMapPoints"
                :trigger-layer="triggerLayer"
                ref="map"
            />
        </div>
    </div>
</template>

<script>
/* eslint-disable global-require */
import { mapState, mapActions, mapGetters } from 'vuex';
import Map from '@/components/Map';
import coreMixin from '@/js/mixin/coreMixin';

export default {
    data() {
        return {
            triggerLayer: false,
        };
    },
    mounted() {},
    computed: {
        ...mapGetters('dataList', ['nearbyAttractionList', 'nearbyQrcodesList']),
        ...mapState('pageData', ['show']),
        oriMapPoints() {
            return {
                attractionListLayer: this.nearbyAttractionList
                    .filter((item) => item.attractionTypeName === '景點')
                    .map((item) => ({
                        ...item,
                        iconUrl: require('@/assets/ic_map_marker_red.png'),
                        callback: () => {
                            this.goGoogleMap([item.lon, item.lat]);
                        },
                    })),
                foodListLayer: this.nearbyAttractionList
                    .filter((item) => item.attractionTypeName === '美食')
                    .map((item) => ({
                        ...item,
                        iconUrl: require('@/assets/ic_map_marker_red.png'),
                        callback: () => {
                            this.goGoogleMap([item.lon, item.lat]);
                        },
                    })),
                commentaryListLayer: this.nearbyAttractionList
                    .filter((item) => item.attractionTypeName === '解說牌')
                    .map((item) => ({
                        ...item,
                        iconUrl: require('@/assets/ic_map_marker_red.png'),
                        callback: () => {
                            this.goGoogleMap([item.lon, item.lat]);
                        },
                    })),
                qrcodesListLayer: this.nearbyQrcodesList
                    .map((item) => ({
                        ...item,
                        iconUrl: require('@/assets/ic_map_marker_red.png'),
                        callback: () => {
                            this.goGoogleMap([item.lon, item.lat]);
                        },
                    })),
            };
        },
    },
    methods: {
        ...mapActions('pageData', ['toggleShow']),
    },
    components: {
        Map,
    },
    mixins: [coreMixin],
};
</script>

<style></style>
